import React from 'react';
import { FaLock, FaMapMarkerAlt, FaVideo, FaEnvelope } from 'react-icons/fa';
import NpsnLogo from '../../assets/npsn_logo.png';
import Header from './Header.js';
import Footer from './Footer.js';

const PrivacyPolicy = () => {
  const contactEmail = 'support@intelserve.io';

  return (
    <>
        <Header appName="IntelServe" />
            <div className="max-w-4xl mx-auto p-8 md:p-12 ">
            <div className="mb-8 border-b pb-4">
                <h1 className="text-4xl font-extrabold text-gray-600 flex items-center">
                <FaLock className="mr-3 text-gray-500" />
                    Privacy Policy
                </h1>
                <p className="mt-2 text-gray-500">
                    Last Updated: October 18, 2025
                </p>
            </div>

            <section className="space-y-8">
                <p className="text-lg text-gray-700">
                IntelServe, ("we," "us," or "our") operates the case management platform. This Privacy Policy describes how we collect, use, and disclose your information when you use our Service.
                </p>

                <h2 className="text-2xl font-semibold text-gray-800">1. Information We Collect</h2>
                <div className="space-y-4">
                <div className="p-4 border-l-4 border-teal-500 bg-white rounded-md shadow-sm">
                    <h3 className="text-xl font-medium text-gray-800 flex items-center">
                    <FaEnvelope className="mr-2 text-teal-600" />
                    User Provided Information
                    </h3>
                    <p className="text-gray-600 mt-1">
                    This includes account registration data (name, email, phone number, company information) and billing details (handled via Stripe).
                    </p>
                </div>
                
                <div className="p-4 border-l-4 border-orange-500 bg-white rounded-md shadow-sm">
                    <h3 className="text-xl font-medium text-gray-800 flex items-center">
                    <FaMapMarkerAlt className="mr-2 text-orange-600" />
                    Operational Data (Crucial)
                    </h3>
                    <p className="text-gray-600 mt-1">
                    To support features like <b>GPS check-in</b>, affidavit generation, and surveillance reporting, we collect and store: <b>Geospatial location data</b> of user devices, document metadata, digital signatures, and case-specific communication logs.
                    </p>
                </div>

                <div className="p-4 border-l-4 border-red-500 bg-white rounded-md shadow-sm">
                    <h3 className="text-xl font-medium text-gray-800 flex items-center">
                    <FaVideo className="mr-2 text-red-600" />
                    Media and Document Content
                    </h3>
                    <p className="text-gray-600 mt-1">
                    Any documents, photos, or video files uploaded for case management purposes (e.g., surveillance footage, proof of service photos) are stored securely on our servers.
                    </p>
                </div>
                </div>

                <h2 className="text-2xl font-semibold text-gray-800">2. How We Use Your Information</h2>
                <ul className="list-disc list-inside ml-4 text-gray-600 space-y-1">
                <li>To provide and maintain the Service, including case management and reporting.</li>
                <li>To verify and document service of process through features like GPS check-in.</li>
                <li>For billing and payment processing.</li>
                </ul>

                <h2 className="text-2xl font-semibold text-gray-800">3. Data Security and Retention</h2>
                <p className="text-gray-600">
                We implement commercially acceptable security measures to protect your data. We retain operational data for as long as your account is active and as necessary to comply with legal obligations.
                </p>

                <h2 className="text-2xl font-semibold text-gray-800">4. Contact Us</h2>
                <p className="text-gray-600">
                If you have questions about this Privacy Policy, you can reach us at: <a href={`mailto:${contactEmail}`} className="text-teal-600 hover:underline"><b>{contactEmail}</b></a>.
                </p>
            </section>
            </div>
       <Footer NpsnLogo={NpsnLogo} />
    </>
  );
};

export default PrivacyPolicy;